import { CommonModule } from "@angular/common";
import { Component, OnInit, ViewChild, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { IonContent, IonicModule, Platform } from "@ionic/angular";
import { Observable, Subject, map, of, switchMap, takeUntil } from "rxjs";

//Services
import { SearchService } from "@providers/SearchService";
import { TrackingService } from "@providers/TrackingService";
import { NewBaseService } from "@providers/newBase.service";
import { DeviceService } from "@services/device.service";
import { SportService } from "@sports-services/index";
import { TicketService } from "@sports-services/index";
import { SportNavigationService } from "@sports-services/index";

//Models
import { GlobalVarsModel } from "@models/ModelGlobalsVar";
import { C_Event } from "@sports-models/index";
import { C_Game } from "@sports-models/index";

// pipes and directives
import { SportsBetDisplayDirective } from "@sports-directives/bet-display/bet-display";
import { SportsExtractDatePipe } from "@sports-pipes/sports.extract-date.pipe";

//component
import { CodereFooterComponent } from "@components/mso/footer/codere-footer/codere-footer";
import {
  SbButtonComponent,
  SbGridContentExpandedComponent,
  SbGridContentTeamsComponent,
  SbGridItemComponent,
  SbHeaderWithCounterComponent,
  SbOverviewScoreRegularComponent,
  SbOverviewScoreSetsComponent,
  SbSimpleNavbarComponent,
} from "@sports-components/index";

// others
import { SPORTS_PATHS } from "@shared-constants/routes";
import { SCOREBOARD_TYPE } from "@sports-utils/sports.constants";

// store
import { NewTicketFacade } from "@sports-features/ticket/stores";
import { TicketItemTypesEnum } from "@sports-pages/ticket/utils/ticket.constants";

@Component({
  selector: "page-special-team",
  templateUrl: "./special-team.page.html",
  styleUrls: ["special-team.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SbSimpleNavbarComponent,
    SbGridItemComponent,
    SbOverviewScoreSetsComponent,
    SbOverviewScoreRegularComponent,
    SbButtonComponent,
    SbGridContentExpandedComponent,
    CodereFooterComponent,
    SbGridContentTeamsComponent,
    SportsExtractDatePipe,
    SportsBetDisplayDirective,
    SbHeaderWithCounterComponent,
  ],
})
export class SpecialTeamPage implements OnInit {
  @ViewChild(IonContent) content: IonContent;
  teamSpecials$: Observable<C_Event[]>;
  teamEvents$: Observable<C_Event[]>;
  isMobile = false;

  team: string;
  camelTeam: string;

  globalVars!: GlobalVarsModel;
  platform = inject(Platform);
  trackingService = inject(TrackingService);
  newTicketFacade = inject(NewTicketFacade);
  sportService = inject(SportService);
  ticketService = inject(TicketService);
  searchService = inject(SearchService);
  sportNavigationService = inject(SportNavigationService);

  extractDate = inject(SportsExtractDatePipe);
  newBaseService = inject(NewBaseService);
  deviceService = inject(DeviceService);
  router = inject(Router);

  private readonly unsubscribe$ = new Subject();

  SCOREBOARD_TYPE = SCOREBOARD_TYPE;

  constructor() {
    this.newBaseService.getVars
      .pipe(
        switchMap((data: GlobalVarsModel) => {
          this.globalVars = data;
          return of(null);
        }),
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe();
    this.isMobile = this.deviceService.isMobile();
    const currentUrl = this.sportNavigationService.navigationState$.getValue().currentUrl;
    this.team = currentUrl.state.params.team;
    this.camelTeam = this.team.replace(/\s/g, "");
  }

  ngOnInit() {
    this.teamEvents$ = this.searchService.getSpecialTeamSearch(this.camelTeam + "Query").pipe(
      map((leagueEvents: C_Event[]) => {
        const events = [];

        leagueEvents.forEach((event) => {
          if (this.setTeamsController(event)) return;
          const e = C_Event.parse(event);
          e.setScoreboardType();
          e.setHomeAndAway();

          e.Games.forEach((game: C_Game) => {
            const g = this.sportService.getGameResultsOrdered(game);
            e.setMode();
            g.setNameOfTeams(e); //este?
          });
          events.push(e);
        });
        return events;
      }),
    );

    this.teamSpecials$ = this.sportService
      .getEventsCountry(this.globalVars.FEATURES[this.camelTeam + "Id"], null)
      .pipe(
        map((specials) =>
          specials.map((special) => {
            special.mode = "expanded";
            return special;
          }),
        ),
      );
  }

  navigate(market, gameType?) {
    if (gameType) {
      return;
    }
    const eventType = market.isLive ? "pushEventLive" : "pushEvent";

    this.router.navigate([SPORTS_PATHS.MercadosPage], { state: { params: market } });
    this.trackingService.trackEvent([eventType, market.NodeId, window.location.hash, market.Name, "event"]);
  }

  public bet(game: any, event: any, gameName: string, type?: string) {
    const data = {
      ...game,
      EventDate: this.extractDate.transform(event.StartDate),
      EventName: event.Name,
      GameName:
        this.isMobile && event.isSixPack ? event.Games.find((i) => i.NodeId === game.GameId).Name : gameName,
    };
    this.newTicketFacade.checkSelection(data, data.NodeId, TicketItemTypesEnum.LINE_ITEM);
  }

  setTeamsController(event) {
    return !!(event.Name.toLowerCase().indexOf("(uru)") !== -1 || event.Name.toLowerCase().indexOf("-uru") !== -1);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
